import { Breakpoint, ThemeColor } from '@/enums'
import { themeBreakpointDown, themeColor, toThemePixels } from '@/utils'
import styled from 'styled-components'
import { Column, Row } from '../../styled'
import { CarrierLogo } from '@/components/atoms'

export const Container = styled(Column)`
  padding: 0 ${toThemePixels(6)};
  gap: ${toThemePixels(6)};

  button {
    margin-top: ${toThemePixels(2)};
  }

  @media (max-width: 900px) {
    padding-bottom: ${toThemePixels(6)};
  }

  ${themeBreakpointDown(Breakpoint.sm)} {
    background-color: ${themeColor(ThemeColor.b10)};
    border-top: 1px solid ${themeColor(ThemeColor.b30)};
    padding: ${toThemePixels(6)};
  }
`

export const MobileContainer = styled(Column)`
  width: 100%;
`

export const MobileCartProductContainer = styled(Row)`
  background: ${(props) => props.theme.color.b10};
  border-radius: 16px;
  padding: 16px;
  min-width: 0;
  gap: 8px;
`

export const CarrierNameAndCategory = styled(Column)`
  flex: 1;
  min-width: 0;
  gap: 4px;
`

export const StyledCarrierLogo = styled(CarrierLogo)`
  background-color: ${(props) => props.theme.color.b0};
  border-radius: 12px;
  border: 1px solid ${(props) => props.theme.color.b30};
  height: 48px;
  width: 48px;
`
